import { registerPlugin } from '@capacitor/core';

import type { SumsubMobileSdkPlugin } from './definitions';

const SumsubMobileSdk = registerPlugin<SumsubMobileSdkPlugin>('SumsubMobileSdk', {
  web: () => import('./web').then((m) => new m.SumsubMobileSdkWeb()),
});

export * from './definitions';
export { SumsubMobileSdk };
